var _rect, _rect2, _rect3, _rect4, _circle, _rect5, _path, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopicPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 100,
    fill: "#F0F3F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    transform: "translate(-485 -414)",
    fill: "#F5F6F9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -421,
    y: -260,
    width: 1311,
    height: 804,
    rx: 8,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -72.5,
    y: -58.5,
    width: 246,
    height: 313,
    rx: 7.5,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 50,
    r: 50,
    fill: "#F5F7FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -72.5,
    y: -58.5,
    width: 246,
    height: 313,
    rx: 7.5,
    stroke: "#A7AABD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.6259 42.037C59.6277 39.9907 55.4551 38.3333 50.3139 38.3333C45.1726 38.3333 41.0037 39.9925 41 42.037M41 42.037C41 44.0833 45.1689 45.7407 50.3139 45.7407C55.4588 45.7407 59.6277 44.0833 59.6277 42.037L59.6277 56.4074M41 42.037V64.2593C41.0019 66.3056 45.1707 67.9631 50.3139 67.9631C52.8081 67.9631 55.0602 67.5686 56.7311 66.9334M41.0019 49.4444C41.0019 51.4908 45.1708 53.1482 50.3157 53.1482C55.4607 53.1482 59.6296 51.4908 59.6296 49.4444M56.8429 59.491C55.1627 60.1484 52.8584 60.5558 50.3139 60.5558C45.1707 60.5558 41.0019 58.8984 41.0019 56.852M70.212 57.441C73.4849 60.6947 73.4849 65.9725 70.212 69.2263C66.9391 72.48 61.6302 72.48 58.3573 69.2263C55.0844 65.9725 55.0844 60.6947 58.3573 57.441C61.6302 54.1872 66.9391 54.1872 70.212 57.441Z",
    stroke: "#2B5297",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -20618,
    y: -33653,
    width: 53660,
    height: 41487,
    stroke: "black",
    strokeWidth: 50
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicPayments);
export default __webpack_public_path__ + "static/media/topic-payments.92b0f32551c6a62f6dad2f4dbc6445f7.svg";
export { ForwardRef as ReactComponent };